import React, { useEffect, useState } from "react";
import { useOutletContext, useSearchParams } from "react-router-dom";
import { nanoid } from "nanoid";
import {
  calcDisplayNo,
  extractClassStudents,
  extractMatricDigits,
} from "../../AppManager";
import MemberCard from "../../components/MemberCard";
import EmptySearch from "../../components/EmptySearch";
import { StudentsLoader } from "./AllStudents";
import Pagination from "../../components/Pagination";

function OverviewStudent() {
  const { search, user, setShowSearch } = useOutletContext();
  const [store, setStore] = useState([]);
  const [students, setStudents] = useState([]);
  const [studentsFetch, setStudentsFetch] = useState(false);
  const [searchParams] = useSearchParams();
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
  });

  useEffect(() => {
    let page = searchParams.get("page") || 1;
    page = parseInt(page);
    page = page > 0 ? page : 1;

    let limit = searchParams.get("limit") || 10;
    limit = parseInt(limit);
    limit = limit > 0 ? limit : 10;
    setPagination({ page, limit });
  }, [searchParams]);

  useEffect(() => {
    const width = 160;
    const height = 220;
    const pagePadMarginWidth = 20;
    const pagePadMarginHeight = 20;
    setPagination((old) => ({
      ...old,
      limit: calcDisplayNo(
        width,
        height,
        pagePadMarginWidth,
        pagePadMarginHeight
      ),
    }));
    window.addEventListener("resize", () => {
      setPagination((old) => ({
        ...old,
        limit: calcDisplayNo(
          width,
          height,
          pagePadMarginWidth,
          pagePadMarginHeight
        ),
      }));
    });

    return () => {
      window.removeEventListener("resize", () => {
        setPagination((old) => ({
          ...old,
          limit: calcDisplayNo(
            width,
            height,
            pagePadMarginWidth,
            pagePadMarginHeight
          ),
        }));
      });
    };
  }, []);

  useEffect(() => {
    setStudentsFetch(false);
    extractClassStudents(user.class)
      .then((data) => {
        setStore(data);
        setStudentsFetch(true);
      })
      .catch((err) => err);
  }, [user]);

  useEffect(() => {
    let data = store.filter(
      (dat) =>
        dat.name.toLowerCase().indexOf(search.toLowerCase()) > -1 ||
        dat.matric.toLowerCase().indexOf(search.toLowerCase()) > -1 ||
        dat.class.toLowerCase().indexOf(search.toLowerCase()) > -1
    );

    setStudents(data);
  }, [search, store]);

  useEffect(() => {
    setShowSearch(true);
  });

  document.title = "Students";

  const { page, limit } = pagination;
  const start = (page - 1) * limit;

  const end = start + limit;
  const studentsElement = students
    .slice(start, end)
    .map((dat) => (
      <MemberCard
        key={dat.matric}
        name={dat.name}
        image={dat.image}
        matric={dat.matric}
        to={extractMatricDigits(dat.matric)}
        imgfolder="students"
      />
    ));
  studentsElement.unshift(
    <MemberCard
      key={nanoid()}
      name={"All Students"}
      image={"user.png"}
      matric={""}
      to={"/overview/allstudents"}
      imgfolder="students"
    />
  );

  return (
    <div className="overview-students">
      {studentsFetch ? (
        studentsElement.length === 0 ? (
          <EmptySearch message={"No Student Found"} />
        ) : (
          <>
            {studentsElement}
            <Pagination
              limit={pagination.limit}
              currentPage={pagination.page}
              totalPages={Math.ceil(students.length / pagination.limit)}
            />
          </>
        )
      ) : (
        <>
          <MemberCard
            key={nanoid()}
            name={"All Students"}
            image={"user.png"}
            matric={""}
            to={"/overview/allstudents"}
            imgfolder="students"
          />
          <StudentsLoader />
        </>
      )}
    </div>
  );
}

export default OverviewStudent;
